import { useTranslation } from 'react-i18next'
import { TableRow, Box, TableCell, Button } from '@mui/material'
import {
  Restriction,
  SportRestrictionObject,
} from '@/state/bonus-engine/models'

import useStyles from '../style'

type Props = {
  row: SportRestrictionObject
  type: 'product' | 'wagerType' | 'sport'
  items: Restriction[]
  handleOnClickSetEnable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
  handleOnClickSetDisable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
  handleOnClickSetDiscardContribution: (
    type: string,
    value: number | string,
  ) => void
}

const RowTableRestrictions = ({
  row,
  type,
  items,
  handleOnClickSetDisable,
  handleOnClickSetEnable,
  handleOnClickSetDiscardContribution,
}: Props) => {
  const { t } = useTranslation()

  const { classes } = useStyles()

  let action: Restriction[] = []

  if (items !== undefined) {
    action = items.filter((item: Restriction) => item.validationId === row.id)
  }

  /* TODO: This will be used later 
  const classCenter = `group center ${
    action.length > 0 && action[0].action === 2 ? 'selected' : ''
  } `

  let classRight = ''
  if (type === 'product') {
    classRight = `group right ${
      action.length > 0 && action[0].action === 3 ? 'selected' : ''
    }`
  } else {
    classRight = `group right ${
      action.length > 0 && action[0].action === 2 ? 'selected' : ''
    }`
  }
  */

  const classRight = `group right ${
    action.length > 0 && action[0].action === 2 ? 'selected' : ''
  }`

  const classLeft = `group left ${
    action.length > 0 && action[0].action === 1 ? 'selected' : ''
  }`

  return (
    <TableRow key={row.name}>
      <TableCell sx={{ width: 200, minWidth: 200 }}>
        <Box display="flex">
          <Box flexGrow={1}>{t(`restrictionsItems.${row.name}`)}</Box>
        </Box>
      </TableCell>

      <TableCell sx={{ width: 200, minWidth: 200 }}>
        <Box
          display="flex"
          ml={0.5}
          justifyContent="center"
          className={classes.rowButtons}
        >
          <Button
            variant="outlined"
            className={classLeft}
            onClick={(e) => {
              handleOnClickSetEnable(type, row.id)
            }}
          >
            {t('restrictions.enabled').toUpperCase()}
          </Button>
          <Button
            variant="outlined"
            /* TODO: This will be used later 
              className={type !== 'product' ? classRight : classCenter} */
            className={classRight}
            onClick={(e) => {
              handleOnClickSetDisable(type, row.id)
            }}
          >
            {t('restrictions.disabled').toUpperCase()}
          </Button>
          {/* TODO: This state will be use later {type === 'product' && (
              <Button
                variant="outlined"
                color="default"
                className={classRight}
                onClick={e => {
                  handleOnClickSetDiscardContribution(type, row.id)
                }}
              >
                {t('restrictions.discard').toUpperCase()}
              </Button>
            )} */}
        </Box>
      </TableCell>
    </TableRow>
  )
}

export default RowTableRestrictions
